import { useReadQuery } from '@apollo/client'
import { useLoaderData } from 'react-router-typesafe'
import { TopGainersTable } from '../../top-gainers/TopGainersTable'
import { CoinPageLoader } from '../CoinPage'
import { TopGainersCardLayout } from './TopGainersCardLayout'

export function TopGainersCard() {
  const queryRef = useLoaderData<CoinPageLoader>()
  const { data } = useReadQuery(queryRef)
  if (!data.coinBySymbol) return null
  return (
    <TopGainersCardLayout
      content={
        <TopGainersTable
          query={data.coinBySymbol.date.topGainers}
          bip44_symbol={data.coinBySymbol.bip44_symbol}
          limit={5}
        />
      }
    />
  )
}
